
export const TicketTypeNewWebsiteTagging = 'website_tagging'
export const TicketTypeAdvertisingSnippet = 'advertising_snippet'
export const TicketTypeBugRequest = 'bug'
export const TicketTypeSupportRequest = 'support'
export const TicketTypeAdobeAnalyticsAccountRequest = 'adobe_analytics_account'
export const TicketTypeCIDValueRequest = 'cid_value'
export const RMH_UI_INTERFACE_ENABLED = 'rmh-ui-interface-enabled'
